
import { mapGetters } from 'vuex';

export default {
    name: 'FarmacieLoader',
    props: {
        isPreloaderSliders: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters({
            isSendCartProcessing: 'farmacieCart/getIsSendCartProcessing'
        })
    }
};
